var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0707 12.772L12.4199 10.1212L10.4404 8.14173L15.0707 3.51148C15.7447 2.83741 15.7447 1.74473 15.0707 1.07066C14.3966 0.396585 13.3039 0.396585 12.6298 1.07066L7.99959 5.7009L3.36976 1.07107C2.69568 0.396992 1.60301 0.396992 0.928934 1.07107C0.25486 1.74514 0.25486 2.83782 0.928934 3.51189L5.55918 8.14213L4.52182 9.17948L0.928931 12.7724C0.254857 13.4465 0.254857 14.5391 0.928931 15.2132C1.603 15.8873 2.69568 15.8873 3.36975 15.2132L8 10.583L12.6302 15.2132C13.3043 15.8873 14.397 15.8873 15.0711 15.2132C15.7451 14.5391 15.7447 13.446 15.0707 12.772Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.e1f093bc4af709f753abf923770d77af.svg";
export { ForwardRef as ReactComponent };